import { render } from "./RepasseAtendimentoPaciente.vue?vue&type=template&id=9222b524&scoped=true"
import script from "./RepasseAtendimentoPaciente.vue?vue&type=script&lang=js"
export * from "./RepasseAtendimentoPaciente.vue?vue&type=script&lang=js"

import "./RepasseAtendimentoPaciente.vue?vue&type=style&index=0&id=9222b524&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9222b524"]])

export default __exports__